import { useState, useEffect, useCallback } from 'react';
import { bffQuery } from '@parsina/framework/clinical/src/lib/bffClient';

const TRANSACTIONS_QUERY = `
  query GetWalletTransactions(
    $ownerId: String!
    $ownerType: String!
    $limit: Int
    $offset: Int
    $startDate: String
    $endDate: String
    $type: String
  ) {
    walletTransactions(
      ownerId: $ownerId
      ownerType: $ownerType
      limit: $limit
      offset: $offset
      startDate: $startDate
      endDate: $endDate
      type: $type
    ) {
      totalCount
      transactions {
        id
        type
        amount
        serviceType
        description
        createdAt
        referenceId
      }
    }
  }
`;

export function useWalletTransactions(doctorId, { limit = 20, offset = 0, startDate, endDate, type } = {}) {
  const [data, setData]       = useState({ transactions: [], totalCount: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const fetch = useCallback(() => {
    if (!doctorId) return;
    setLoading(true);
    bffQuery(TRANSACTIONS_QUERY, {
      ownerId:   doctorId,
      ownerType: 'doctor',
      limit,
      offset,
      startDate: startDate ?? '',
      endDate:   endDate   ?? '',
      // Server-side: the ledger runs to thousands of rows, so a filter applied
      // to the fetched page would describe only that page.
      type:      type ?? '',
    })
      .then(res => {
        setData(res?.walletTransactions ?? { transactions: [], totalCount: 0 });
        setError(null);
      })
      .catch(err => setError(err))
      .finally(() => setLoading(false));
  }, [doctorId, limit, offset, startDate, endDate, type]);

  useEffect(() => { fetch(); }, [fetch]);

  return { ...data, loading, error, refetch: fetch };
}
